import { IconCircle, SectionHeader } from "./shared";
import whyImage from "../../assets/home/why-choose.jpg";
import iconPercent from "../../assets/home/icon-percent.svg";
import iconClock from "../../assets/home/icon-clock.svg";
import iconBriefcase from "../../assets/home/icon-briefcase.svg";
import iconRupee from "../../assets/home/icon-rupee-lg.svg";

const ITEMS = [
  { title: "Low Interest Rates", desc: "Competitive rates to help make borrowing more affordable.", icon: iconPercent, size: 19 },
  { title: "Low Processing Fee", desc: "Know the processing charges upfront, with transparent fee details.", icon: iconClock, size: 19 },
  { title: "For Salaried Professionals", desc: "Designed for professionals whose salary is credited directly to their bank account.", icon: iconBriefcase, size: 19 },
  { title: "No Payment Charges", desc: "No extra charges for making your payment.", icon: iconRupee, size: 16 },
];

export default function HomeWhyChoose() {
  return (
    <section className="bg-white px-4 sm:px-6 lg:px-[80px] pt-[60px] pb-[60px]">
      <div className="max-w-[1280px] mx-auto">
        <SectionHeader
          badge="The FastRupees Advantage"
          title="Why Choose FastRupees?"
          subtitle="Simple, transparent and designed around your salary."
        />

        <div className="mt-10 lg:mt-[95px] flex flex-col lg:flex-row gap-8">
          <div className="w-full lg:w-[560px] shrink-0 flex flex-col gap-4">
            {ITEMS.map((item) => (
              <div
                key={item.title}
                className="flex items-start gap-4 bg-[#f8fafc] border border-[rgba(92,22,138,0.5)] rounded-[12px] p-[11px] lg:h-[66px]"
              >
                <IconCircle size={38}>
                  <img alt="" src={item.icon} style={{ width: item.size, height: item.size }} />
                </IconCircle>
                <div className="min-w-0">
                  <p className="font-bold text-[#1a1a4b] text-[16px]">{item.title}</p>
                  <p className="mt-[3px] text-[#6a7282] text-[13px] leading-[18px]">{item.desc}</p>
                </div>
              </div>
            ))}
            <p className="bg-[#f8fafc] rounded-[16px] px-4 py-[11px] text-[#5c168a] text-[12px] leading-[16px]">
              Rates, fees and eligibility are subject to applicable terms. Clearly disclose the applicable APR and total repayment.
            </p>
          </div>

          <div className="relative flex-1 min-w-0">
            <div className="h-[260px] sm:h-[360px] rounded-[24px] overflow-hidden bg-[#f8fafc]">
              <img src={whyImage} alt="Salaried professional reviewing her loan online" loading="lazy" className="size-full object-cover" />
            </div>
            <div className="mt-4 lg:mt-0 lg:absolute lg:left-[27px] lg:bottom-[-30px] bg-[#f8fafc] border-[1.289px] border-[rgba(91,22,140,0.5)] rounded-[28px] lg:rounded-full px-[20.6px] py-[10.3px] font-extrabold text-[#5b168c] text-[13px] lg:text-[15.47px] tracking-[1.547px] uppercase">
              “First 5 Days Interest-Free” benefit, subject to applicable
              <br className="hidden lg:block" /> terms and conditions and compliance approval.
            </div>
          </div>
        </div>

        <a
          href="/products"
          className="mt-8 lg:mt-[25px] inline-flex items-center justify-center h-12 w-full sm:w-[220px] bg-[#5c168a] rounded-full font-bold text-[16px] text-white whitespace-nowrap transition-opacity hover:opacity-90"
        >
          Explore Personal Loans
        </a>
      </div>
    </section>
  );
}
